import { render, staticRenderFns } from "./ot-textarea-wrapper.vue?vue&type=template&id=5b644ada&scoped=true&"
import script from "./ot-textarea-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-textarea-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-textarea-wrapper.vue?vue&type=style&index=0&id=5b644ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b644ada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
